var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9416_5013)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    transform: "rotate(90 20 20)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 11.6625C16.7798 11.3697 16.3297 11.3482 16.0368 11.6125L11.6613 15.563C11.6578 15.5665 11.6542 15.5701 11.6506 15.5737C11.6292 15.5951 11.6078 15.6165 11.5899 15.6415C11.5792 15.6558 11.5649 15.6701 11.5542 15.6844C11.5363 15.7094 11.522 15.738 11.5042 15.7666C11.497 15.7808 11.4899 15.7916 11.4827 15.8059C11.4685 15.8416 11.4577 15.8773 11.447 15.9166C11.4435 15.9273 11.4399 15.9344 11.4399 15.9452C11.4292 15.9916 11.4256 16.0416 11.4256 16.0916C11.4256 16.1416 11.4327 16.1916 11.4399 16.238C11.4435 16.2488 11.447 16.2559 11.447 16.2666C11.4577 16.3023 11.4685 16.3416 11.4827 16.3773C11.4899 16.3916 11.497 16.4023 11.5042 16.4166C11.5185 16.4452 11.5328 16.4738 11.5542 16.4988C11.5649 16.5131 11.5756 16.5274 11.5899 16.5416C11.6078 16.5666 11.6292 16.5881 11.6506 16.6095C11.6542 16.6131 11.6578 16.6167 11.6613 16.6202L16.0368 20.5707C16.3297 20.835 16.7798 20.8135 17.0441 20.5206C17.3084 20.2278 17.2869 19.7741 16.9941 19.5134L13.9973 16.8095L27.8559 16.8095C28.2488 16.8095 28.5703 16.4881 28.5703 16.0952C28.5703 15.7023 28.2488 15.3808 27.8559 15.3808L13.9973 15.3808L16.9941 12.6769C17.2869 12.4091 17.3084 11.9554 17.0441 11.6625ZM11.4256 23.9067C11.4256 24.2996 11.7471 24.6211 12.14 24.6211L25.9986 24.6211L23.0019 27.325C22.8447 27.4643 22.7661 27.6607 22.7661 27.8572C22.7661 28.0286 22.8268 28.2001 22.9518 28.3358C23.2162 28.6287 23.6662 28.6501 23.9591 28.3858L28.3346 24.4389C28.3381 24.4354 28.3417 24.4318 28.3453 24.4282C28.3774 24.3996 28.4024 24.3675 28.431 24.3318C28.431 24.3282 28.4346 24.3282 28.4346 24.3246C28.5203 24.2068 28.5703 24.0639 28.5703 23.9067C28.5703 23.7496 28.5203 23.6067 28.4346 23.4888C28.4346 23.4853 28.431 23.4853 28.431 23.4817C28.406 23.446 28.3774 23.4138 28.3453 23.3852C28.3417 23.3817 28.3381 23.3781 28.3346 23.3745L23.9591 19.4277C23.6662 19.1634 23.2162 19.1848 22.9518 19.4777C22.6875 19.7706 22.7125 20.2206 23.0019 20.4849L25.9986 23.1888L12.14 23.1888C11.7471 23.1924 11.4256 23.5138 11.4256 23.9067Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9416_5013",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9416_5013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9416_5013",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.cb6454d5973f3bc74ce76ce311bd686d.svg";
export { ForwardRef as ReactComponent };